<template>
    <div>
        <div class="map-container mb-3">
            <div id="profiles-map" style="height: 700px; width: 100%;"></div>
        </div>
    </div>
</template>

<script>
import { toRaw } from 'vue';
import "leaflet/dist/leaflet.css";
import L from "leaflet";

export default {
    props: {
        dataProfiles: {
            default: false,
            type: String,
        },
        dataRadius: {
            required: true,
            type: String,
        },
        dataLat: {
            required: true,
            type: String,
        },
        dataLong: {
            required: true,
            type: String,
        }
    },
    data() {
        return {
            map: null,
            layerGroup: null,
            provider: null,
            profiles: JSON.parse(this.dataProfiles),
        };
    },
    mounted() {
        this.map = L.map('profiles-map', { zoomControl: false }).setView([51.844154, 6.858323], 10);

        this.layerGroup = new L.FeatureGroup().addTo(toRaw(this.map));
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(toRaw(this.map));

        for (const [key, value] of Object.entries(this.profiles)) {
            if (value.longitude && value.latitude) {
                let marker = L.marker([value.longitude, value.latitude]).addTo(toRaw(this.layerGroup));
                marker.bindTooltip(value.company.name, { permanent: true, direction: 'right' });
                marker.bindPopup('<img class="mb-3" src="/images/companys/cropped-' + value.logo + '"><a href="/unternehmen/profile/' + value.id + '">' + value.company.name + '</a><br>' + value.plz + ' ' + value.city + '<br><br><a href="/unternehmen/profile/' + value.id + '">Profil anzeigen</a>');
            }
        }

        if (this.dataRadius && this.dataLong && this.dataLat) {
            L.circle([this.dataLong, this.dataLat], {
                color: '#f8ab14',
                fillColor: '#f8ab14',
                fillOpacity: 0.2,
                radius: this.dataRadius * 1000
            }).addTo(this.layerGroup);
        }

        this.map.fitBounds(this.layerGroup.getBounds());
    },
};
</script>
